import React from 'react';
import {
  Grid,
  TextField,
  FormControl,
  InputLabel,
  Select,
  MenuItem,
  FormHelperText
} from "@material-ui/core";
import { Controller } from 'react-hook-form';
import timezones from '../../../../../../../../utils/timezones';


function IntegrationForm(props){
  const { isEditableForm } = props;
  const { domain, client_secret, integration_backend, timezone_name } = props.data || {};  
  const { register, errors, control, watch } = props.formConfig; 
  const watchIntegrationBackend = watch("integration_backend", integration_backend || "WCONLINE") ; 
  const isWCOnline = watchIntegrationBackend === "WCONLINE";

  return (
    <form noValidate autoComplete="off" >      
        <Grid container spacing={3} direction="row">
        
        <Grid item xs={12}>          
            <FormControl 
              variant="filled" 
              fullWidth={true}
              error={errors.integration_backend ? true : false}
              disabled={!isEditableForm}
              >
              <InputLabel id="integration_backend-label">Integration backend</InputLabel>
              <Controller
                as={
                  <Select labelId="integration_backend-label">
                    <MenuItem value={'WCONLINE'}>WCOnline</MenuItem>
                  </Select>
                }
                name="integration_backend"
                rules={{ required: "this is required" }}
                control={control}
                defaultValue={integration_backend || props.integration_backend || 'WCONLINE'}
              />
              <FormHelperText>{errors.integration_backend ? errors.integration_backend.message : null}</FormHelperText>
              
            </FormControl>
          </Grid>

          {isWCOnline && (       
            <React.Fragment>       
            <Grid item xs={12}>
              <TextField 
                label="Domain"
                name="domain"
                placeholder="Ex: demo.mywconline.com"
                variant="filled"
                disabled={!isEditableForm}
                fullWidth={true}

                defaultValue={domain}
                inputRef={register({ required: true, minLength: { value: 3, message: "Too short!." } })}
                error={errors.domain ? true : false}
                helperText={errors.domain ? errors.domain.message : null}
              />
            </Grid>

            <Grid item xs={12}>
              <TextField 
                id="filled-basic"
                label="API Key"
                name="client_secret"
                placeholder="Client Secret"
                variant="filled"
                disabled={!isEditableForm}
                fullWidth={true}
                type="password"

                defaultValue={client_secret}
                inputRef={register({ required: true, minLength: { value: 3, message: "Too short!." } })}
                error={errors.client_secret ? true : false}
                helperText={errors.client_secret ? errors.client_secret.message : null}
              />
            </Grid>

            <Grid item xs={12}>      
              <FormControl 
                variant="filled" 
                fullWidth={true}
                error={errors.timezone_name ? true : false}
                disabled={!isEditableForm}
                >
                <InputLabel id="timezone_name-label">Timezone</InputLabel>
                <Controller
                  as={
                    <Select labelId="timezone_name-label">
                      {timezones  && timezones.map( (timezone_name, index) => (
                      <MenuItem value={timezone_name} key={`${timezone_name}_${index}`}>{timezone_name}</MenuItem>
                      ))}
                    </Select>
                  }
                  name="timezone_name"
                  rules={{ required: "this is required" }}
                  control={control}
                  defaultValue={timezone_name || props.timezone_name || 'America/New_York'}
                />
                <FormHelperText>{errors.timezone_name ? errors.timezone_name.message : null}</FormHelperText>
                
              </FormControl>
            </Grid>

            </React.Fragment>
          )}
        
          {/* Show Form action buttons only when Edit action is active */}
          {props.children}
        </Grid>
    </form>
  )
}

export default IntegrationForm;